let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dB0Hl")).then(() => parcelRequire('MTexj'));